import { SuperAdminService } from "services/superAdminService";
class FeaturesSAService extends SuperAdminService<any> {
  constructor() {
    super("features");
  }

  async create(data: any) {
    return this.post(data);
  }

  async update(id: number, data: any) {
    return this.put(id, data);
  }
}
export default new FeaturesSAService();
